import { makeStyles } from "@material-ui/core";

export const useCardSincronizacaoStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
    },
    defaultContainer: {
        position: "relative",
        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden"
    },
    table: {
        minWidth: 650,
        justifyContent: 'center'
    },
    aplicacaoSub: {
        width: '100%',
        background: '#fff',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.07)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    containerSituacao: {
        width: '100%',
        height: '28px',
        maxWidth: '83px',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    divider: {
        width: '100%',
        height: '1px',
        marginBottom: 8,
        backgroundColor: 'rgba(223, 223, 223, 0.3)'
    },
    titleTelas: {
        color: '#696969',
        fontSize: '22px',
        [theme.breakpoints.down("xs")]: {
            fontSize: '20px',
        },
    },
    titleSituacao: {
        color: '#fff',
        fontSize: '12px',
        fontWeight: 700,
        [theme.breakpoints.down("xs")]: {
            fontSize: '10px',
            fontWeight: 700,
        },
    },
    titleSub: {
        color: '#5F5F5F',
        fontSize: '16px',
        fontWeight: 700,
        [theme.breakpoints.down("xs")]: {
            fontSize: '13px',
        },
    },
    titleSinc: {
        color: '#696969',
        fontSize: '15px',
        padding: '10px 8px',
        marginRight: '5rem'
    },
    titleStatus: {
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        height: '30px',
        color: '#FFFFFF',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    btnDownload: {
        margin: '0 0 0 35px'
    },
    card: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.palette.grey[50]
        }
    },
    cardCinza: {
        background: theme.palette.grey[100],
        '&:hover': {
            backgroundColor: theme.palette.grey[200]
        }
    }
}));
